import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUntappdComponent } from './simple-icons-untappd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUntappdComponent ],
    exports:      [ SimpleIconsUntappdComponent ],
    bootstrap:    []
})
export class SimpleIconsUntappdModule {}
